import React, { useState } from 'react';

interface RuleInterface {
    title: string;
    rule: string;
};

interface RuleSectionInterface {
    number: string;
    title: string;
    rules: RuleInterface[];
}

function RuleSection({number, title, rules} : RuleSectionInterface) {
    const downArrowIcon = require("./images/downArrow.png");
    const upArrowIcon = require("./images/upArrow.png");

    const [isOpen, setIsOpen] = useState(number === "01");

    const handleRuleSectionHeaderClick = () => {
        setIsOpen(!isOpen);
    }

    return (
        <div className="ruleSectionWrapper">
            <div className="ruleSectionHeader">
                <div className="ruleSectionHeaderNumberAndTitleWrapper">
                    <div className="ruleSectionNumber">{number}</div>
                    <div className="ruleSectionTitle">{title}</div>
                </div>
                <div className="ruleSectionArrowWrapper" tabIndex={0} onClick={handleRuleSectionHeaderClick} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleRuleSectionHeaderClick();
                    }
                }}>
                    {isOpen ? <img className="ruleSectionArrowIcon" src={upArrowIcon} alt="up arrow"/>
                    : <img className="ruleSectionArrowIcon" src={downArrowIcon} alt="down arrow"/> }
                </div>
            </div>
            {isOpen && <div className="ruleSectionRulesWrapper">
                {rules.map((rule, idx) => {
                    return <div className="ruleSectionRuleLineWrapper" key={idx}>
                        <div className="ruleSectionRuleLine">
                            <div className="ruleSectionLine1"></div>
                            <div className="ruleSectionLine2"></div>
                            <div className="ruleSectionLine3"></div>
                        </div>
                        <div className="ruleSectionRuleWrapper">
                            <div className="ruleSectionRuleTitle">{rule.title}</div>
                            <div className="ruleSectionRuleContent">{rule.rule}</div>
                        </div>
                    </div>
                })}
            </div>}
        </div>
    );
}

function Rules() {
    const ruleSections: RuleSectionInterface[] = [
        {
            number: "01",
            title: "THE SETUP",
            rules: [
                { title: "RED AND BLACK", rule: "The game consists of red cards and black cards. Red cards represent pet peeves. Black cards represent karma." },
                { title: "DRAW YOUR HAND", rule: "Each player draws 7 black cards. Every round has a judge." },
            ]
        },
        {
            number: "02",
            title: "THE ROAST SUBJECT",
            rules: [
                { title: "PICK A PLAYER", rule: "The judge draws a red card that has a number on the top. For example, if the number is 3, then it's the 3rd player from judge's left." },
                { title: "SKIP THE JUDGE", rule: "If the number lands on the judge, we move one more spot." },
            ]
        },
        {
            number: "03",
            title: "THE CHAOS",
            rules: [
                { title: "START THE ROAST", rule: "The judge reads the red card about that player." },
                { title: "PLAY KARMA", rule: "Everyone (except for the judge) plays a black card for the pet peeve." },
            ]
        },
        {
            number: "04",
            title: "THE WINNER",
            rules: [
                { title: "WINNER OF THE ROUND", rule: "The judge reads the cards out loud and picks the best karma, and the player that played it gets a point." },
                { title: "WINNER OF THE GAME", rule: "We move to the next round with a new judge. First player to 5 points wins." },
            ]
        }
    ];

    return (
        <div className="rulesOuterWrapper">
            <div className="rulesInnerWrapper">
                <div className="rulesTitle">RULES</div>
                <div className="rulesHowToPlay">HOW TO PLAY</div>
                <div className="rulesSections">
                    {ruleSections.map((section, idx) => {
                        return <RuleSection key={idx} number={section.number} title={section.title} rules={section.rules}/>
                    })}
                </div>
            </div>
        </div>
    );
};

export default Rules;